import styles from './question-step.module.scss';
import { LEVEL_COLORS } from '../tech-due-diligence-quiz.data';
import { Level, QuestionEntry } from '../tech-due-diligence-quiz.types';

const LEVELS: Level[] = ['L4', 'L3', 'L2', 'L1'];

type QuestionStepProps = {
  entry: QuestionEntry;
  selected: Level | undefined;
  onAnswer: (level: Level) => void;
};

const QuestionStep = ({ entry, selected, onAnswer }: QuestionStepProps) => {
  const { section, question } = entry;

  return (
    <div className={styles.page}>
      <div className={styles.question}>
        {LEVELS.map((level) => (
          <label key={level} className={`${styles.option} ${selected === level ? styles.selected : ''}`}>
            <span className={styles.indicator} style={{ background: LEVEL_COLORS[level] }} />
            <span className={styles.radioBox}>
              <input
                type="radio"
                name={`${section.id}-${entry.qIndex}`}
                checked={selected === level}
                onChange={() => onAnswer(level)}
                onClick={() => {
                  if (selected === level) onAnswer(level);
                }}
                className={styles.radioInput}
              />
              <span className={styles.radioVisual} />
            </span>
            <span className={styles.optionText}>{question.levels[level]}</span>
          </label>
        ))}
        <div className={styles.why}>
          <strong>WHY IT MATTERS</strong>
          {'  '}
          {question.why}
        </div>
      </div>
    </div>
  );
};

export default QuestionStep;
